export const requestTypes = {
	holiday: 1,
	absence: 2
};

